import BettingsNotAllowed from "./BettingsNotAllowed";
import { Context } from "../../App";
import HomeContent from "./HomeContent";
import LoggedHomePage from "./LoggedHomePage";

export default function HomePage(props) {
  const {
    showHomeScreen,
    login,
    accountFeatures,
    userData,
    setAndGetUserData,
    setentradasLigth,
    setentradasPro,
    statusMode,
    setStatusMode,
    isLoggedIn,
    showLogoutButton,
    notificationVolume,
    setNotificationVolume,
    valueMin,
    setValueMin,
    valueMax,
    setValueMax,
    betHome,
    setBetHome,
    sports,
    setSports,
    timeEvent,
    setTimeEvent,
    itemsTrash,
    setItemsTrash,
    controllerLocalStorage,
    quantityBetHomeEnabled,
    setQuantityBetHomeEnabled,
    quantitySportsEnabled,
    setQuantitySportsEnabled,
    setlistBehomeEnableds,
    AparecerProf,
    setAparecerProf,
    AparecerVivo,
    setAparecerVivo,
    AparecerLight,
    setAparecerLight,
    AparecerPro,
    setAparecerPro,
    filterOrder,
    setFilterOrder,
    requiredBetHome,
    setRequiredBetHome,
    marketsUnselected,
    setMarketsUnselected,
    clearOldSurebet,
    blacklistWords,
    setBlacklistWords,
    popupWindow,
    setPopupWindow,
    popuwindowsBet,
    setPopupWindowBet,
    canGetOperation,
  } = props;

  if (!showHomeScreen) {
    return null;
  } //---

  const plano = userData?.plano?.toLocaleLowerCase() || "";
  const hasActivePlan =
    login === true &&
    accountFeatures.current.length > 0 &&
    plano !== "inativo" &&
    plano !== "gratuito";

  if (hasActivePlan) {
    return canGetOperation ? (
      <LoggedHomePage {...props} />
    ) : (
      <BettingsNotAllowed
        showHomeScreen={showHomeScreen}
        login={login}
        userData={userData}
        statusMode={statusMode}
        setStatusMode={setStatusMode}
        isLoggedIn={isLoggedIn}
        showLogoutButton={showLogoutButton}
        notificationVolume={notificationVolume}
        setNotificationVolume={setNotificationVolume}
      />
    );
  }

  if (login === false) {
    return (
      <Context.Provider
        value={{ setAndGetUserData, setentradasLigth, setentradasPro }}
      >
        <HomeContent />
      </Context.Provider>
    );
  }

  return null;
}
